export default __webpack_public_path__ + "static/char-s-40-ko-4b9452c756599cb9600d548f277839c8.png";